<template>
  <form v-on:submit.prevent="submit">
    <div class="form-group">
      <label class="form-label" for="fencer">Choose an existing fencer</label>
      <select class="form-select" id="fencer" v-model="fencer" v-on:change="changeFencer">
        <option value="">Choose a fencer</option>
        <option v-for="fencer in fencers" :value="fencer.id">
          {{fencer.lastname}}, {{fencer.firstname}}: {{fencer.club.name}}
        </option>
      </select>
    </div>

    <div class="line">OR</div>

    <div class="form-group">
      <label class="form-label" for="firstname">First name</label>
      <input class="form-input" type="text" id="firstname" v-model="firstname" min="0" />
    </div>

    <div class="form-group">
      <label class="form-label" for="lastname">Last name</label>
      <input class="form-input" type="text" id="lastname" v-model="lastname" min="0" />
    </div>

    <div class="form-group">
      <label class="form-label" for="club">Club</label>
      <select class="form-select" id="club" v-model="club">
        <option v-for="club in clubs" :value="club.id">
          {{club.name}}
        </option>
      </select>
    </div>
    <a href="#" v-on:click.prevent="newClub">New club</a>
    <div id="newClub" v-bind:style="{ display : showClub }">
      <newclub></newclub>
    </div>


    <div class="actions">
      <button type="reset" class="btn">Reset</button>
      &nbsp;
      <button type="submit" class="btn btn-primary">Create new</button>
    </div>

  </form>
</template>

<script>
  import { EventBus } from '../main'
  import config from "../config"
  import uuid from "../../node_modules/uuid/v4"
  import newclub from '@/components/clubForm'

  // TODO: add in autofill for the clubs
  export default {
    name : "newcomp",
    components : {
      newclub
    },
    data () {
      return {
        firstname : "",
        lastname : "",
        club : "una",
        clubs : [{
          uuid : "una",
          name : "unaffiliated"
        }],
        showClub : "none",
        fencers : [],
        fencer : "",
        originalId : ""
      }
    },
    methods : {
      submit : function(e){
        fetch(config.baseUrl+"competitors/create", {
          method : "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials : "include",
          body : JSON.stringify({
            firstname : this.firstname,
            lastname : this.lastname,
            club : this.club,
            originalid : this.originalId ? this.originalId : null
          })
        }).then(e => {
          return e.json()
        }).then(j => {
          // fire an event here
          // clear the form
          this.fencer = ""
          this.firstname = ""
          this.lastname = ""
          this.club = ""
          EventBus.$emit('newCompetitor', j)
        })
      },
      setData : function(d, d2){
        this.clubs = d
        this.fencers = d2
      },
      newClub: function(e){
        if(this.showClub == "none") this.showClub = "block"
        else this.showClub = "none"
      },
      getData: function(){
        return new Promise((resolve, reject) => {
          // fetch in clubs
          fetch(config.baseUrl+"clubs/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j => {
            fetch(config.baseUrl+"user/fencers/", {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j2 => {
              this.setData(j, j2)
              resolve()
            }).catch(err => {
              reject(err)
            })
          })
        })
      },
      changeFencer: function(e){
        this.fencers.forEach(f => {
          if(f.id == this.fencer){
            this.firstname = f.firstname
            this.lastname = f.lastname
            this.club = f.club.id
            this.originalId = f.id
          }
        })
      }
    },
    created : function(){
      this.getData()

      EventBus.$on("newClub", (data) => {
        this.showClub = "none"
        this.clubs.push(data)
        this.club = data.uuid
      })

    }
  }
</script>
